import { render, staticRenderFns } from "./SupplierCommunicateDetail.vue?vue&type=template&id=085175f8&scoped=true"
import script from "./SupplierCommunicateDetail.vue?vue&type=script&lang=ts"
export * from "./SupplierCommunicateDetail.vue?vue&type=script&lang=ts"
import style0 from "./SupplierCommunicateDetail.vue?vue&type=style&index=0&id=085175f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085175f8",
  null
  
)

export default component.exports